import React from 'react';
import { connect } from 'react-redux';
import Dashboard from './Dashboard';
import { actions } from '../dashboard.actions';
import { actions as carrierActions } from '../../carrier/carrier.actions';
import { actions as locationActions } from '../../location/location.actions';
// import { actionsValueFreightByLocation } from '../../../store/reports/freightvaluebylocation';
// import { actionsNfeDeliveredLate } from '../../../store/reports/nfeDeliveredLate';

import { AppService, COMPANY_CHANGE_EVENT_NAME, BUSINESS_UNIT_CHANGE_EVENT_NAME } from '../../../services/app.service';



import { Column } from 'primereact/column';
import { actionsPedidosAguardPlanejamento } from '../../../store/reports/pedidosAguaPlanejamento';
import { actionsRoteirizadorIndicator } from '../../../store/reports/roteirizador/index';
import { actionsDeliveriesCarrier } from '../../../store/reports/deliveriesCarrier';
import { actionsDeliveriesByApp } from '../../../store/reports/deliveriesByApp';
import { actionsAuditoriaIndicator } from '../../../store/reports/auditoria';

function findMenu(oidMenu, menuItems) {
  let menuFinded = null
  menuItems.forEach(menuItem => {
    if (menuItem.oid === oidMenu) {
      menuFinded = menuItem
    }
    if (menuItem.items) {
      const resultChildren = findMenu(oidMenu, menuItem.items)
      if (resultChildren) {
        menuFinded = resultChildren
      }
    }
  });
  return menuFinded
}

function isChildMenu(oidMenu, menuItems) {
  let isChild = false;
  menuItems.forEach(menuItem => {
    if (menuItem.oid === oidMenu) {
      isChild = true
      return;
    }
    if (menuItem.items && isChildMenu(oidMenu, menuItem.items)) {
      isChild = true;
      return;
    }
  });

  return isChild
}
function findMenuParent(oidMenu, menuItems) {
  let parentMenu = null
  menuItems.forEach(menuItem => {

    if (menuItem.items && isChildMenu(oidMenu, menuItem.items)) {
      parentMenu = menuItem
    }
  });
  return parentMenu
}

const mapStateToProps = state => {
  const appState = state.appState;
  const menuState = state.menuState;
  const userConfigurations = appState.userConfigurations ? appState.userConfigurations : null;
  let userFavorites = [];
  let userLastAccesses = [];


  if (userConfigurations) {
    userFavorites = userConfigurations.favorites ? userConfigurations.favorites : [];
    userLastAccesses = userConfigurations.lastAccesses ? userConfigurations.lastAccesses : [];
  }

  const menuItems = menuState.items;
  const allCarriersOption = { name: "TODOS", tradeName: "Mblog", documentNumber: "" }
  const periodOptions = [
    { description: "Mês atual", period: "CURRENT_MONTH" },
    { description: "Últimos 7 dias", period: "LAST_SEVEN_DAYS" },
    { description: "Últimos 15 dias", period: "LAST_FIFTEEN_DAYS" },
    { description: "Últimos 30 dias", period: "LAST_THIRTY_DAYS" },
    { description: "Últimos 2 meses", period: "LAST_TWO_MONTHS" },
    { description: "Últimos 3 meses", period: "LAST_THREE_MONTHS" },
    { description: "Últimos 6 meses", period: "LAST_SIX_MONTHS" },
    { description: "Último ano", period: "LAST_YEAR" }]

  const pedidosAguaPlanejamentoParams = {
    carrier: state.crudPedidosAguardPlanejamento.pedidosAguardPlanejamento.filters.carrier.name,
    period: state.crudPedidosAguardPlanejamento.pedidosAguardPlanejamento.filters.period.description,
    countPedidosAguaPlanejamento: state.crudPedidosAguardPlanejamento.pedidosAguardPlanejamento.countPedidosAguaPlanejamento,

    lookup: {
      carrier: {
        show: state.crudPedidosAguardPlanejamento.pedidosAguardPlanejamento.lookup.showCarrier,
        columns: state.crudPedidosAguardPlanejamento.pedidosAguardPlanejamento.lookup.columnsCarrier,
        records: [allCarriersOption, ...state.crudCarrierState.records],
        columns: state.crudCarrierState.columns.filter(col => col.field === 'name').map(col => <Column key={col.field} {...col} />),
        first: state.crudCarrierState.page > 0 ? state.crudCarrierState.page * (state.crudCarrierState.max + 1) : state.crudCarrierState.index,
        rows: state.crudCarrierState.max < 15 ? state.crudCarrierState.max + 1 : 15,
        totalRecords: state.crudCarrierState.count + 1,
      },
      period: {
        show: state.crudPedidosAguardPlanejamento.pedidosAguardPlanejamento.lookup.showPeriod,
        columns: [{
          field: "description",
          header: "Período",
          columnKey: "period",
          sortable: false,
          filter: false
        }].map(col => <Column key={col.field} {...col} />),
        records: periodOptions,
        first: 0,
        rows: 10,
        totalRecords: periodOptions.length,
      }
    }
  }

  const roteirizadorParams = {
    carrier: state.crudRoteirizadorIndicator.roteirizador.filters.carrier.name,
    period: state.crudRoteirizadorIndicator.roteirizador.filters.period.description,
    countCargasCriadas: state.crudRoteirizadorIndicator.roteirizador.countCargasCriadas,

    lookup: {
      carrier: {
        show: state.crudRoteirizadorIndicator.roteirizador.lookup.showCarrier,
        columns: state.crudRoteirizadorIndicator.roteirizador.lookup.columnsCarrier,
        records: [allCarriersOption, ...state.crudCarrierState.records],
        columns: state.crudCarrierState.columns.filter(col => col.field === 'name').map(col => <Column key={col.field} {...col} />),
        first: state.crudCarrierState.page > 0 ? state.crudCarrierState.page * (state.crudCarrierState.max + 1) : state.crudCarrierState.index,
        rows: state.crudCarrierState.max < 15 ? state.crudCarrierState.max + 1 : 15,
        totalRecords: state.crudCarrierState.count + 1,
      },
      period: {
        show: state.crudRoteirizadorIndicator.roteirizador.lookup.showPeriod,
        columns: [{
          field: "description",
          header: "Período",
          columnKey: "period",
          sortable: false,
          filter: false
        }].map(col => <Column key={col.field} {...col} />),
        records: periodOptions,
        first: 0,
        rows: 10,
        totalRecords: periodOptions.length,
      }
    }
  }

  const deliveriesCarriersParams = {
    carrier: state.crudDeliveriesCarrier.deliveriesCarriers.filters.carrier.name,
    period: state.crudDeliveriesCarrier.deliveriesCarriers.filters.period.description,
    values: state.crudDeliveriesCarrier.deliveriesCarriers.values,

    lookup: {
      carrier: {
        show: state.crudDeliveriesCarrier.deliveriesCarriers.lookup.showCarrier,
        columns: state.crudDeliveriesCarrier.deliveriesCarriers.lookup.columnsCarrier,
        records: [allCarriersOption, ...state.crudCarrierState.records],
        columns: state.crudCarrierState.columns.filter(col => col.field === 'name').map(col => <Column key={col.field} {...col} />),
        first: state.crudCarrierState.page > 0 ? state.crudCarrierState.page * (state.crudCarrierState.max + 1) : state.crudCarrierState.index,
        rows: state.crudCarrierState.max < 15 ? state.crudCarrierState.max + 1 : 15,
        totalRecords: state.crudCarrierState.count + 1,
      },
      period: {
        show: state.crudDeliveriesCarrier.deliveriesCarriers.lookup.showPeriod,
        columns: [{
          field: "description",
          header: "Período",
          columnKey: "period",
          sortable: false,
          filter: false
        }].map(col => <Column key={col.field} {...col} />),
        records: periodOptions,
        first: 0,
        rows: 10,
        totalRecords: periodOptions.length,
      }
    }
  }

  const deliveriesByAppParams = {
    carrier: state.crudDeliveriesByApp.deliveriesByApp.filters.carrier.name,
    period: state.crudDeliveriesByApp.deliveriesByApp.filters.period.description,
    values: state.crudDeliveriesByApp.deliveriesByApp.values,

    lookup: {
      carrier: {
        show: state.crudDeliveriesByApp.deliveriesByApp.lookup.showCarrier,
        columns: state.crudDeliveriesByApp.deliveriesByApp.lookup.columnsCarrier,
        records: [allCarriersOption, ...state.crudCarrierState.records],
        columns: state.crudCarrierState.columns.filter(col => col.field === 'name').map(col => <Column key={col.field} {...col} />),
        first: state.crudCarrierState.page > 0 ? state.crudCarrierState.page * (state.crudCarrierState.max + 1) : state.crudCarrierState.index,
        rows: state.crudCarrierState.max < 15 ? state.crudCarrierState.max + 1 : 15,
        totalRecords: state.crudCarrierState.count + 1,
      },
      period: {
        show: state.crudDeliveriesByApp.deliveriesByApp.lookup.showPeriod,
        columns: [{
          field: "description",
          header: "Período",
          columnKey: "period",
          sortable: false,
          filter: false
        }].map(col => <Column key={col.field} {...col} />),
        records: periodOptions,
        first: 0,
        rows: 10,
        totalRecords: periodOptions.length,
      }
    }
  }

  const auditoriaParams = {
    carrier: state.crudAuditoriaIndicator.auditoria.filters.carrier.name,
    period: state.crudAuditoriaIndicator.auditoria.filters.period.description,
    values: state.crudAuditoriaIndicator.auditoria.values,

    lookup: {
      carrier: {
        show: state.crudAuditoriaIndicator.auditoria.lookup.showCarrier,
        columns: state.crudAuditoriaIndicator.auditoria.lookup.columnsCarrier,
        records: [allCarriersOption, ...state.crudCarrierState.records],
        columns: state.crudCarrierState.columns.filter(col => col.field === 'name').map(col => <Column key={col.field} {...col} />),
        first: state.crudCarrierState.page > 0 ? state.crudCarrierState.page * (state.crudCarrierState.max + 1) : state.crudCarrierState.index,
        rows: state.crudCarrierState.max < 15 ? state.crudCarrierState.max + 1 : 15,
        totalRecords: state.crudCarrierState.count + 1,
      },
      period: {
        show: state.crudAuditoriaIndicator.auditoria.lookup.showPeriod,
        columns: [{
          field: "description",
          header: "Período",
          columnKey: "period",
          sortable: false,
          filter: false
        }].map(col => <Column key={col.field} {...col} />),
        records: periodOptions,
        first: 0,
        rows: 10,
        totalRecords: periodOptions.length,
      }
    }
  }

  const nfeRecord = state.crudDashboardNfeState.currentRecord;

  return {
    userFavorites,
    userLastAccesses,
    menuItems,
    pedidosAguaPlanejamentoParams,
    roteirizadorParams,
    nfeRecord,
    deliveriesCarriersParams,
    deliveriesByAppParams,
    auditoriaParams
  }
}

function onConfirmCarrier(e, dispatch, action) {
  let value = { name: "Todas", documentNumber: "" }
  if (e.selection) {
    value.name = e.selection.name
    value.documentNumber = e.selection.documentNumber
  }
  dispatch(action.setCNPJ(value));
  dispatch(action.setShowCarrier(false))
  dispatch(action.load())
}

function onConfirmLocation(e, dispatch, action) {
  let value = { name: "Todos", initials: "", zipCode: "" }
  if (e.selection) {
    value.name = e.selection.name
    value.initials = e.selection.initials
    value.zipCode = e.selection.zipCode
  }
  dispatch(action.setLocation(value))
  dispatch(action.setShowLocation(false))
  dispatch(action.load())
}

function onConfirmPeriod(e, dispatch, action) {
  let value = { description: "Mês atual", period: "CURRENT_MONTH" }
  if (e.selection) {
    value = e.selection
  }
  dispatch(action.setPeriod(value));
  dispatch(action.setShowPeriod(false));
  dispatch(action.load());
}



const mapDispatchToProps = dispatch => {
  return {
    loadUserConfigurations: () => dispatch(actions.loadUserConfigurations()),

    //FILTERS SEARCH CARRIER
    loockupCarrierOnFilter: (filterParams) => {
      dispatch(carrierActions.applyFilter(filterParams))
      dispatch(carrierActions.load())
    },

    lookupCarrierOnPage: paginationParams => dispatch(carrierActions.paginate(paginationParams)),

    setLookupPeriodAguardPlanejamentoVisible: (visible) => {
      dispatch(actionsPedidosAguardPlanejamento.setShowPeriod(visible))
    },
    onConfirmPeriodoPedidosAguaPlanejamento: (e) => {
      onConfirmPeriod(e, dispatch, actionsPedidosAguardPlanejamento)
    },

    loadIndicators: () => {
      dispatch(actionsPedidosAguardPlanejamento.load())
      dispatch(actionsRoteirizadorIndicator.load())
      dispatch(actionsDeliveriesCarrier.load())
      dispatch(actionsDeliveriesByApp.load())
      dispatch(actionsAuditoriaIndicator.load())
    },
    // aguardando planejamento
    lookupPeriodoOnPage: paginationParams => dispatch(carrierActions.paginate(paginationParams)),

    //roteirizador
    setLookupCarrierRoteirizadorVisible: (visible) => {
      if (visible) {
        dispatch(carrierActions.paginate({
          max: 14,
          index: 0,
          page: 0
        }));
        dispatch(carrierActions.applyFilter([], { reload: false }))
        dispatch(carrierActions.load())
      }
      dispatch(actionsRoteirizadorIndicator.setShowCarrier(visible))
    },

    onConfirmCarrierRoteirizador: (e) => {
      onConfirmCarrier(e, dispatch, actionsRoteirizadorIndicator)
    },


    setLookupPeriodRoteirizadorVisible: (visible) => {
      dispatch(actionsRoteirizadorIndicator.setShowPeriod(visible))
    },
    onConfirmPeriodRoteirizador: (e) => {
      onConfirmPeriod(e, dispatch, actionsRoteirizadorIndicator)
    },

    setLookupCarrierPeriodoAguardPlanejamentoVisible: (visible) => {
      dispatch(actionsPedidosAguardPlanejamento.setShowCarrier(visible))
    }

    //deliveriesCarrier
    , setLookupCarrierDeliveriesVisible: (visible) => {
      if (visible) {
        dispatch(carrierActions.paginate({
          max: 14,
          index: 0,
          page: 0
        }));
        dispatch(carrierActions.applyFilter([], { reload: false }))
        dispatch(carrierActions.load())
      }
      dispatch(actionsDeliveriesCarrier.setShowCarrier(visible))
    },
    setLookupPeriodDeliveriesVisible: (visible) => {
      dispatch(actionsDeliveriesCarrier.setShowPeriod(visible))
    },

    onConfirmCarrierDeliveries: (e) => {
      onConfirmCarrier(e, dispatch, actionsDeliveriesCarrier)
    },
    onConfirmPeriodDeliveries: (e) => {
      onConfirmPeriod(e, dispatch, actionsDeliveriesCarrier)
    },

    //deliveriesByApp
    setLookupCarrierDeliveriesByAppVisible: (visible) => {
      if (visible) {
        dispatch(carrierActions.paginate({
          max: 14,
          index: 0,
          page: 0
        }));
        dispatch(carrierActions.applyFilter([], { reload: false }))
        dispatch(carrierActions.load())
      }
      dispatch(actionsDeliveriesByApp.setShowCarrier(visible))
    },
    setLookupPeriodDeliveriesByAppVisible: (visible) => {
      dispatch(actionsDeliveriesByApp.setShowPeriod(visible))
    },
    onConfirmCarrierDeliveriesByApp: (e) => {
      onConfirmCarrier(e, dispatch, actionsDeliveriesByApp)
    },
    onConfirmPeriodDeliveriesByApp: (e) => {
      onConfirmPeriod(e, dispatch, actionsDeliveriesByApp)
    },

    //auditoria
    setLookupCarrierAuditoriaVisible: (visible) => {
      if (visible) {
        dispatch(carrierActions.paginate({
          max: 14,
          index: 0,
          page: 0
        }));
        dispatch(carrierActions.applyFilter([], { reload: false }))
        dispatch(carrierActions.load())
      }
      dispatch(actionsAuditoriaIndicator.setShowCarrier(visible))
    },
    setLookupPeriodAuditoriaVisible: (visible) => {
      dispatch(actionsAuditoriaIndicator.setShowPeriod(visible))
    },
    onConfirmCarrierAuditoria: (e) => {
      onConfirmCarrier(e, dispatch, actionsAuditoriaIndicator)
    },
    onConfirmPeriodAuditoria: (e) => {
      onConfirmPeriod(e, dispatch, actionsAuditoriaIndicator)
    },

  }
}

class DashboardPageContainer extends React.Component {


  componentDidMount() {
    AppService.on(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
    // this.props.loadExpectedAndRealizedData();
    // this.props.loadUserConfigurations()
    this.props.loadIndicators();
  }
  componentWillUnmount() {
    AppService.off(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }

  onReceiveAppNotifications = (eventName, params) => {
    if (eventName === COMPANY_CHANGE_EVENT_NAME || eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME) {
      // this.props.loadExpectedAndRealizedData();
      this.props.loadIndicators();
    }
    // this.props.loadUserConfigurations()
  }

  lookupCarrierOnPage = (e) => {
    this.props.lookupCarrierOnPage({
      max: e.rows - 1,
      index: e.first > 0 ? e.first - e.page : 0,
      page: e.page
    })
  }

  setLockupCarrierOnFilter = (e) => {
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach(key => {
      filters.push({
        campo: key,
        valor: e.filters[key].value,
        tipoFiltro: 'CONTEM'

      })
    })
    console.log(filters);
    this.props.loockupCarrierOnFilter(filters)
  }


  render() {
    const lastAccessedRecords = [];
    const dashboardParams = {
      lastAccessedRecords: lastAccessedRecords ? lastAccessedRecords.reverse() : [],

      pedidosAguaPlanejamento: {
        countPedidosAguaPlanejamento: this.props.pedidosAguaPlanejamentoParams.countPedidosAguaPlanejamento,
        carrier: this.props.pedidosAguaPlanejamentoParams.carrier,
        period: this.props.pedidosAguaPlanejamentoParams.period,
        lookup: {
          carrier: {
            disabled: true,
          },
          period: {
            enabled: true,
            columns: this.props.pedidosAguaPlanejamentoParams.lookup.period.columns,
            records: this.props.pedidosAguaPlanejamentoParams.lookup.period.records,
            totalRecords: this.props.pedidosAguaPlanejamentoParams.lookup.period.totalRecords,
            first: this.props.pedidosAguaPlanejamentoParams.lookup.period.first,
            show: this.props.pedidosAguaPlanejamentoParams.lookup.period.show,
            rowsPerPageOptions: [10],
            rows: this.props.pedidosAguaPlanejamentoParams.lookup.period.rows,
            onHide: () => { this.props.setLookupPeriodAguardPlanejamentoVisible(false) },
            onConfirm: this.props.onConfirmPeriodoPedidosAguaPlanejamento,
            onCancel: () => { this.props.setLookupPeriodAguardPlanejamentoVisible(false) },
            onPage: this.props.lookupPeriodoOnPage,
            onFilter: () => { },
          }
        },
        btnCarrierOnClick: () => { this.props.setLookupCarrierPeriodoAguardPlanejamentoVisible(true) },
        btnPeriodoOnClick: () => { this.props.setLookupPeriodAguardPlanejamentoVisible(true) },
      },


      roteirizador: {
        countCargasCriadas: this.props.roteirizadorParams.countCargasCriadas,
        carrier: this.props.roteirizadorParams.carrier,
        period: this.props.roteirizadorParams.period,
        lookup: {
          carrier: {
            disabled: false,
            columns: this.props.roteirizadorParams.lookup.carrier.columns,
            records: this.props.roteirizadorParams.lookup.carrier.records,
            totalRecords: this.props.roteirizadorParams.lookup.carrier.totalRecords,
            first: this.props.roteirizadorParams.lookup.carrier.first,
            show: this.props.roteirizadorParams.lookup.carrier.show,
            rowsPerPageOptions: [15],
            rows: this.props.roteirizadorParams.lookup.carrier.rows,
            onHide: () => { this.props.setLookupCarrierRoteirizadorVisible(false) },
            onConfirm: this.props.onConfirmCarrierRoteirizador,
            onCancel: () => { this.props.setLookupCarrierRoteirizadorVisible(false) },
            onPage: this.lookupCarrierOnPage,
            onFilter: () => { },
          },
          period: {
            columns: this.props.roteirizadorParams.lookup.period.columns,
            records: this.props.roteirizadorParams.lookup.period.records,
            totalRecords: this.props.roteirizadorParams.lookup.period.totalRecords,
            first: this.props.roteirizadorParams.lookup.period.first,
            show: this.props.roteirizadorParams.lookup.period.show,
            rowsPerPageOptions: [10],
            rows: this.props.roteirizadorParams.lookup.period.rows,
            onHide: () => { this.props.setLookupPeriodRoteirizadorVisible(false) },
            onConfirm: this.props.onConfirmPeriodRoteirizador,
            onCancel: () => { this.props.setLookupPeriodRoteirizadorVisible(false) },
            onPage: this.props.lookupPeriodoOnPage,
            onFilter: () => { },
          }
        },
        btnCarrierOnClick: () => { this.props.setLookupCarrierRoteirizadorVisible(true) },
        btnPeriodoOnClick: () => { this.props.setLookupPeriodRoteirizadorVisible(true) },
      },

      deliveriesCarriers: {
        countEntregas: this.props.deliveriesCarriersParams.countEntregas,
        carrier: this.props.deliveriesCarriersParams.carrier,
        period: this.props.deliveriesCarriersParams.period,
        values: this.props.deliveriesCarriersParams.values,
        lookup: {
          carrier: {
            columns: this.props.deliveriesCarriersParams.lookup.carrier.columns,
            records: this.props.deliveriesCarriersParams.lookup.carrier.records,
            totalRecords: this.props.deliveriesCarriersParams.lookup.carrier.totalRecords,
            first: this.props.deliveriesCarriersParams.lookup.carrier.first,
            show: this.props.deliveriesCarriersParams.lookup.carrier.show,
            rowsPerPageOptions: [15],
            rows: this.props.deliveriesCarriersParams.lookup.carrier.rows,
            onHide: () => { this.props.setLookupCarrierDeliveriesVisible(false) },
            onConfirm: this.props.onConfirmCarrierDeliveries,
            onCancel: () => { this.props.setLookupCarrierDeliveriesVisible(false) },
            onPage: this.lookupCarrierOnPage,
            onFilter: () => { },
          },
          period: {
            columns: this.props.deliveriesCarriersParams.lookup.period.columns,
            records: this.props.deliveriesCarriersParams.lookup.period.records,
            totalRecords: this.props.deliveriesCarriersParams.lookup.period.totalRecords,
            first: this.props.deliveriesCarriersParams.lookup.period.first,
            show: this.props.deliveriesCarriersParams.lookup.period.show,
            rowsPerPageOptions: [10],
            rows: this.props.deliveriesCarriersParams.lookup.period.rows,
            onHide: () => { this.props.setLookupPeriodDeliveriesVisible(false) },
            onConfirm: this.props.onConfirmPeriodDeliveries,
            onCancel: () => { this.props.setLookupPeriodDeliveriesVisible(false) },
            onPage: this.props.lookupPeriodoOnPage,
            onFilter: () => { },
          }
        },
        btnCarrierOnClick: () => { this.props.setLookupCarrierDeliveriesVisible(true) },
        btnPeriodoOnClick: () => { this.props.setLookupPeriodDeliveriesVisible(true) },
      },

      deliveriesByApp: {
        countEntregas: this.props.deliveriesByAppParams.countEntregas,
        carrier: this.props.deliveriesByAppParams.carrier,
        period: this.props.deliveriesByAppParams.period,
        values: this.props.deliveriesByAppParams.values,
        lookup: {
          carrier: {
            disabled: true,
            columns: this.props.deliveriesByAppParams.lookup.carrier.columns,
            records: this.props.deliveriesByAppParams.lookup.carrier.records,
            totalRecords: this.props.deliveriesByAppParams.lookup.carrier.totalRecords,
            first: this.props.deliveriesByAppParams.lookup.carrier.first,
            show: this.props.deliveriesByAppParams.lookup.carrier.show,
            rowsPerPageOptions: [15],
            rows: this.props.deliveriesByAppParams.lookup.carrier.rows,
            onHide: () => { this.props.setLookupCarrierDeliveriesByAppVisible(false) },
            onConfirm: this.props.onConfirmCarrierDeliveriesByApp,
            onCancel: () => { this.props.setLookupCarrierDeliveriesByAppVisible(false) },
            onPage: this.lookupCarrierOnPage,
            onFilter: () => { },
          },
          period: {
            columns: this.props.deliveriesByAppParams.lookup.period.columns,
            records: this.props.deliveriesByAppParams.lookup.period.records,
            totalRecords: this.props.deliveriesByAppParams.lookup.period.totalRecords,
            first: this.props.deliveriesByAppParams.lookup.period.first,
            show: this.props.deliveriesByAppParams.lookup.period.show,
            rowsPerPageOptions: [10],
            rows: this.props.deliveriesByAppParams.lookup.period.rows,
            onHide: () => { this.props.setLookupPeriodDeliveriesByAppVisible(false) },
            onConfirm: this.props.onConfirmPeriodDeliveriesByApp,
            onCancel: () => { this.props.setLookupPeriodDeliveriesByAppVisible(false) },
            onPage: this.props.lookupPeriodoOnPage,
            onFilter: () => { },
          }
        },
        btnCarrierOnClick: () => { this.props.setLookupCarrierDeliveriesByAppVisible(true) },
        btnPeriodoOnClick: () => { this.props.setLookupPeriodDeliveriesByAppVisible(true) },
      },

      auditoria: {
        countEntregas: this.props.auditoriaParams.countEntregas,
        carrier: this.props.auditoriaParams.carrier,
        period: this.props.auditoriaParams.period,
        values: this.props.auditoriaParams.values,
        lookup: {
          carrier: {
            columns: this.props.auditoriaParams.lookup.carrier.columns,
            records: this.props.auditoriaParams.lookup.carrier.records,
            totalRecords: this.props.auditoriaParams.lookup.carrier.totalRecords,
            first: this.props.auditoriaParams.lookup.carrier.first,
            show: this.props.auditoriaParams.lookup.carrier.show,
            rowsPerPageOptions: [15],
            rows: this.props.auditoriaParams.lookup.carrier.rows,
            onHide: () => { this.props.setLookupCarrierAuditoriaVisible(false) },
            onConfirm: this.props.onConfirmCarrierAuditoria,
            onCancel: () => { this.props.setLookupCarrierAuditoriaVisible(false) },
            onPage: this.lookupCarrierOnPage,
            onFilter: () => { },
          },
          period: {
            columns: this.props.auditoriaParams.lookup.period.columns,
            records: this.props.auditoriaParams.lookup.period.records,
            totalRecords: this.props.auditoriaParams.lookup.period.totalRecords,
            first: this.props.auditoriaParams.lookup.period.first,
            show: this.props.auditoriaParams.lookup.period.show,
            rowsPerPageOptions: [10],
            rows: this.props.auditoriaParams.lookup.period.rows,
            onHide: () => { this.props.setLookupPeriodAuditoriaVisible(false) },
            onConfirm: this.props.onConfirmPeriodAuditoria,
            onCancel: () => { this.props.setLookupPeriodAuditoriaVisible(false) },
            onPage: this.props.lookupPeriodoOnPage,
            onFilter: () => { },
          }
        },
        btnCarrierOnClick: () => { this.props.setLookupCarrierAuditoriaVisible(true) },
        btnPeriodoOnClick: () => { this.props.setLookupPeriodAuditoriaVisible(true) },
      },


      nfeRecord: this.props.nfeRecord
    }

    return (<Dashboard dashboardParams={dashboardParams} />);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPageContainer);
